import React, { useEffect, useState } from 'react';
import { AccountsReceivableReport } from '../../../../shared/reports/Financial/AccountsReceivable';
import api from '../../../../services/api';
import { IFinancial } from '../../../../shared/interfaces';
import { useToast } from '../../../../hooks/toast';
import {
  AButton,
  PageIntro,
  PageLayout,
  PagePanel,
} from '../../../../components';
import { ArrowLeftOutlined, PrinterOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const AccountsReceivablePage: React.FC = () => {
  const [data, setData] = useState<IFinancial[]>([]);
  const { addToast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get('/financials/reports/accounts-receivable')
      .then((response) => {
        setData(response.data);
      })
      .catch(() => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: 'Erro ao carregar relatório',
        });
      });
  }, [addToast]);

  return (
    <PageLayout>
      <PageIntro
        badge="Relatórios"
        icon={<PrinterOutlined />}
        title="Contas a receber"
        description="Acompanhe o consolidado de recebimentos em uma visualização padronizada com o restante do sistema."
        actions={
          <AButton
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/financials')}
          >
            Voltar
          </AButton>
        }
      />
      <PagePanel>
        <AccountsReceivableReport financials={data} />
      </PagePanel>
    </PageLayout>
  );
};
export default AccountsReceivablePage;
